module.exports = __webpack_public_path__ + "static/media/isdoctorplan-general3@2x.cdddc9ba.png";